import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { ResponsiveModalFooter } from '@mdvip/shared/components/blocks/ResponsiveModal';
import { Button } from '@mdvip/shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface EditModalFooterProps {
  screen: 'form' | 'confirm';
  onCancel: () => void;
  onReview: () => void;
  reviewDisabled: boolean;
  onMakeChanges: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
}

/**
 * Footer for the Edit Payment Account modals — identical copy and screen-switch shape between the
 * card and bank variants, so it's shared rather than duplicated. Each caller keeps its own
 * form/mutation state and just supplies callbacks + flags here.
 */
export function EditModalFooter({
  screen,
  onCancel,
  onReview,
  reviewDisabled,
  onMakeChanges,
  onConfirm,
  isSubmitting,
}: EditModalFooterProps) {
  const { t } = useTranslation('members');

  return (
    <ResponsiveModalFooter
      note={
        <>
          <Icon name="lock" weight="solid" size="xs" /> {t('payments.addAccount.secureNote')}
        </>
      }
    >
      {screen === 'form' ? (
        <>
          <Button type="button" variant="outline" onClick={onCancel}>
            {t('payments.addAccount.cancel')}
          </Button>
          <Button type="button" onClick={onReview} disabled={reviewDisabled}>
            {t('payments.addAccount.review')}
          </Button>
        </>
      ) : (
        <>
          <Button type="button" variant="outline" onClick={onMakeChanges}>
            <Icon name="pencil" size="sm" /> {t('payments.addAccount.reviewScreen.makeChanges')}
          </Button>
          <Button type="button" onClick={onConfirm} disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <Icon name="spinner" weight="solid" size="sm" className="animate-spin" />{' '}
                {t('payments.addAccount.reviewScreen.submitting')}
              </>
            ) : (
              <>
                <Icon name="check" weight="solid" size="sm" /> {t('payments.addAccount.reviewScreen.confirmSubmit')}
              </>
            )}
          </Button>
        </>
      )}
    </ResponsiveModalFooter>
  );
}
